import { Link } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import PlayNavigationIcon from '@/components/layout/playShell/PlayNavigationIcon'
import { trackHomeTileClick } from '@/routes/home/homeMetrics'
import styles from './HomeSecondaryActivities.module.scss'

export default function HomeSecondaryActivities({ ready }: { ready: boolean }) {
  const { t } = useI18n()
  return (
    <nav className={styles.activities} aria-label={t('hub.exploreTitle')}>
      {(['online', 'challenges', 'arcade'] as const).map(id => (
        <Link
          key={id}
          to={'/' + id}
          className={`${styles.activity} ${styles[id]}`}
          data-testid={'home-play-' + id}
          aria-disabled={!ready || undefined}
          onClick={event => {
            if (!ready) event.preventDefault()
            else trackHomeTileClick(id, '/' + id)
          }}
        >
          <span className={styles.icon}>
            <PlayNavigationIcon id={id} />
          </span>
          <div className={styles.copy}>
            <h3>{t('common.playNavigation.' + id)}</h3>
            <p>{t('hub.tiles.' + id + '.desc')}</p>
            <span className={styles.action}>
              {t('hub.tiles.' + id + '.cta')} <span aria-hidden="true">→</span>
            </span>
          </div>
        </Link>
      ))}
    </nav>
  )
}
